import type { NavigateFunction } from 'react-router-dom';
import type { NavigatePayload } from './actions';

let navigateRef: NavigateFunction | null = null;

export const setNavigate = (navigate: NavigateFunction) => {
  navigateRef = navigate;
};

export const navigateTo = (to: NavigatePayload, replace = false) => {
  if (navigateRef) {
    navigateRef(to, { replace });
    return;
  }

  const path =
    typeof to === 'string' ? to : `${to.pathname}${to.search ?? ''}${to.hash ?? ''}`;
  if (replace) {
    window.location.replace(path);
  } else {
    window.location.assign(path);
  }
};
